import { render, staticRenderFns } from "./removeod.vue?vue&type=template&id=946d3c36&scoped=true"
import script from "./removeod.vue?vue&type=script&lang=js"
export * from "./removeod.vue?vue&type=script&lang=js"
import style0 from "./removeod.vue?vue&type=style&index=0&id=946d3c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946d3c36",
  null
  
)

export default component.exports